import EventsService from './events-service'

class EventsHandler {
    constructor (selector, event) {
        this.defaults = { name: null, action: null, category: null, label: null }
        this.selector = selector
        this.event = event
        this.callback = this.callback.bind(this)
        document.addEventListener(this.event, this.callback)
    }
 
    callback (e) {
        if (e.target && e.target.matches(this.selector)) {
            this.trigger(e.target)
        } else if ( e.target.closest(this.selector) ) {
            this.trigger(e.target.closest(this.selector))
        }
    }

    trigger (el) {
        const {
            dlEvent,
        } = el.dataset

        if (dlEvent) {
            let args = Object.assign(this.defaults, dlEvent ? JSON.parse(dlEvent) : {})

            // allow to change args depending on extension
            args = this.prepareArgs(args, el)

            if (args.name) {
                const name = args.name
                delete args.name

                EventsService.sendEvent(name, args)
            }
        }
    }

    prepareArgs (args, el) {
        return args
    }
}

export default EventsHandler